import { useSyncExternalStore } from 'react';

type ResetOrientationAcknowledgementListener = () => void;

export type ResetOrientationAcknowledgementVariant = 'success' | 'error';

type ResetOrientationAcknowledgementState = {
  nonce: number;
  open: boolean;
  variant: ResetOrientationAcknowledgementVariant;
};

let resetOrientationAcknowledgementState: ResetOrientationAcknowledgementState = {
  nonce: 0,
  open: false,
  variant: 'success',
};

const resetOrientationAcknowledgementListeners = new Set<ResetOrientationAcknowledgementListener>();

const notifyResetOrientationAcknowledgementListeners = () => {
  resetOrientationAcknowledgementListeners.forEach((listener) => listener());
};

const subscribeToResetOrientationAcknowledgement = (listener: ResetOrientationAcknowledgementListener) => {
  resetOrientationAcknowledgementListeners.add(listener);

  return () => {
    resetOrientationAcknowledgementListeners.delete(listener);
  };
};

const getResetOrientationAcknowledgementSnapshot = () => resetOrientationAcknowledgementState;

const showResetOrientationNotification = (variant: ResetOrientationAcknowledgementVariant) => {
  resetOrientationAcknowledgementState = {
    nonce: resetOrientationAcknowledgementState.nonce + 1,
    open: false,
    variant,
  };
  notifyResetOrientationAcknowledgementListeners();
  queueMicrotask(() => {
    resetOrientationAcknowledgementState = {
      ...resetOrientationAcknowledgementState,
      open: true,
    };
    notifyResetOrientationAcknowledgementListeners();
  });
};

export const showResetOrientationAcknowledgement = () => {
  showResetOrientationNotification('success');
};

export const showResetOrientationFailure = () => {
  showResetOrientationNotification('error');
};

export const closeResetOrientationAcknowledgement = () => {
  if (!resetOrientationAcknowledgementState.open) {
    return;
  }

  resetOrientationAcknowledgementState = {
    ...resetOrientationAcknowledgementState,
    open: false,
  };
  notifyResetOrientationAcknowledgementListeners();
};

export const useResetOrientationAcknowledgementState = () =>
  useSyncExternalStore(
    subscribeToResetOrientationAcknowledgement,
    getResetOrientationAcknowledgementSnapshot,
    getResetOrientationAcknowledgementSnapshot
  );
